var nunjucks = require("nunjucks/browser/nunjucks-slim");
var env;
if (!nunjucks.currentEnv){
	env = nunjucks.currentEnv = new nunjucks.Environment([], undefined);
} else {
	env = nunjucks.currentEnv;
}
var configure = require("../../../../../config/frontend/nunjucks.config.js")(env);
var dependencies = nunjucks.webpackDependencies || (nunjucks.webpackDependencies = {});
dependencies["front/utils/macros.jinja"] = require( "front/utils/macros.jinja" );
dependencies["front/components/StyleTag/StyleTag.jinja"] = require( "front/components/StyleTag/StyleTag.jinja" );




var shim = require("/app/node_modules/nunjucks-loader/runtime-shim");


(function() {(nunjucks.nunjucksPrecompiled = nunjucks.nunjucksPrecompiled || {})["assets/app/front/components/TagList/TagList.jinja"] = (function() {
function root(env, context, frame, runtime, cb) {
var lineno = 0;
var colno = 0;
var output = "";
try {
var parentTemplate = null;
env.getTemplate("front/utils/macros.jinja", false, "assets/app/front/components/TagList/TagList.jinja", false, function(t_2,t_1) {
if(t_2) { cb(t_2); return; }
t_1.getExported(function(t_3,t_1) {
if(t_3) { cb(t_3); return; }
if(Object.prototype.hasOwnProperty.call(t_1, "svgSprite")) {
var t_4 = t_1.svgSprite;
} else {
cb(new Error("cannot import 'svgSprite'")); return;
}
context.setVariable("svgSprite", t_4);
output += "\n";
env.getTemplate("front/components/StyleTag/StyleTag.jinja", false, "assets/app/front/components/TagList/TagList.jinja", false, function(t_6,t_5) {
if(t_6) { cb(t_6); return; }
t_5.getExported(function(t_7,t_5) {
if(t_7) { cb(t_7); return; }
if(Object.prototype.hasOwnProperty.call(t_5, "StyleTag")) {
var t_8 = t_5.StyleTag;
} else {
cb(new Error("cannot import 'StyleTag'")); return;
}
context.setVariable("StyleTag", t_8);
output += "\n\n";
var macro_t_9 = runtime.makeMacro(
["tags"], 
["activeTags", "classes"], 
function (l_tags, kwargs) {
var callerFrame = frame;
frame = new runtime.Frame();
kwargs = kwargs || {};
if (Object.prototype.hasOwnProperty.call(kwargs, "caller")) {
frame.set("caller", kwargs.caller); }
frame.set("tags", l_tags);
frame.set("activeTags", Object.prototype.hasOwnProperty.call(kwargs, "activeTags") ? kwargs["activeTags"] : []);frame.set("classes", Object.prototype.hasOwnProperty.call(kwargs, "classes") ? kwargs["classes"] : "");var t_10 = "";t_10 += "\n    <div class=\"TagList ";
t_10 += runtime.suppressValue(runtime.contextOrFrameLookup(context, frame, "classes"), env.opts.autoescape);
t_10 += "\">\n        <div class=\"TagList-list\">\n            ";
frame = frame.push();
var t_13 = l_tags;
if(t_13) {t_13 = runtime.fromIterator(t_13);
var t_12 = t_13.length;
for(var t_11=0; t_11 < t_13.length; t_11++) {
var t_14 = t_13[t_11];
frame.set("t", t_14);
frame.set("loop.index", t_11 + 1);
frame.set("loop.index0", t_11);
frame.set("loop.revindex", t_12 - t_11);
frame.set("loop.revindex0", t_12 - t_11 - 1);
frame.set("loop.first", t_11 === 0);
frame.set("loop.last", t_11 === t_12 - 1);
frame.set("loop.length", t_12);
t_10 += "\n                ";
t_10 += runtime.suppressValue((lineno = 7, colno = 27, runtime.callWrap(runtime.contextOrFrameLookup(context, frame, "StyleTag"), "StyleTag", context, [t_14,runtime.makeKeywordArgs({"classes": (runtime.inOperator(runtime.memberLookup((t_14),"id"),env.getFilter("map").call(context, runtime.contextOrFrameLookup(context, frame, "activeTags"),runtime.makeKeywordArgs({"attribute": "id"})))?"isActive":"")})])), env.opts.autoescape);
t_10 += "\n            ";
;
}
}
frame = frame.pop();
t_10 += "\n        </div>\n        \n        <div class=\"TagList-more\" tabindex=\"0\">\n            <div class=\"TagList-button\">\n                ";
t_10 += runtime.suppressValue((lineno = 13, colno = 28, runtime.callWrap(runtime.contextOrFrameLookup(context, frame, "svgSprite"), "svgSprite", context, ["ellipsis"])), env.opts.autoescape);
t_10 += "\n            </div>\n\n            <div class=\"TagList-tooltip\">\n                <div class=\"TagList-tooltipOverlay\"></div>\n                <div class=\"TagList-tooltipContent\">\n                    ";
frame = frame.push();
var t_17 = l_tags;
if(t_17) {t_17 = runtime.fromIterator(t_17);
var t_16 = t_17.length;
for(var t_15=0; t_15 < t_17.length; t_15++) {
var t_18 = t_17[t_15];
frame.set("t", t_18);
frame.set("loop.index", t_15 + 1);
frame.set("loop.index0", t_15);
frame.set("loop.revindex", t_16 - t_15);
frame.set("loop.revindex0", t_16 - t_15 - 1);
frame.set("loop.first", t_15 === 0);
frame.set("loop.last", t_15 === t_16 - 1);
frame.set("loop.length", t_16);
t_10 += "\n                        ";
t_10 += runtime.suppressValue((lineno = 20, colno = 35, runtime.callWrap(runtime.contextOrFrameLookup(context, frame, "StyleTag"), "StyleTag", context, [t_18,runtime.makeKeywordArgs({"classes": (runtime.inOperator(runtime.memberLookup((t_18),"id"),env.getFilter("map").call(context, runtime.contextOrFrameLookup(context, frame, "activeTags"),runtime.makeKeywordArgs({"attribute": "id"})))?"isActive":"")})])), env.opts.autoescape);
t_10 += "\n                    ";
;
}
}
frame = frame.pop();
t_10 += "\n                </div>\n            </div>\n        </div>\n    </div>\n";
;
frame = callerFrame;
return new runtime.SafeString(t_10);
});
context.addExport("TagList");
context.setVariable("TagList", macro_t_9);
output += "\n\n";
if(runtime.contextOrFrameLookup(context, frame, "render") == true) {
output += "\n    ";
output += runtime.suppressValue((lineno = 29, colno = 14, runtime.callWrap(macro_t_9, "TagList", context, [runtime.contextOrFrameLookup(context, frame, "tags")])), env.opts.autoescape);
output += "\n";
;
}
output += "\n";
if(parentTemplate) {
parentTemplate.rootRenderFunc(env, context, frame, runtime, cb);
} else {
cb(null, output);
}
})})})});
} catch (e) {
  cb(runtime.handleError(e, lineno, colno));
}
}
return {
root: root
};

})();
})();



module.exports = shim(nunjucks, env, nunjucks.nunjucksPrecompiled["assets/app/front/components/TagList/TagList.jinja"] , dependencies)